/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DashboardPage = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The DashboardPage model module.
   * @module model/DashboardPage
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>DashboardPage</code>.
   * @alias module:model/DashboardPage
   * @class
   */
  var exports = function() {
    var _this = this;
























  };

  /**
   * Constructs a <code>DashboardPage</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DashboardPage} obj Optional instance to populate.
   * @return {module:model/DashboardPage} The populated <code>DashboardPage</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('GroupID')) {
        obj['GroupID'] = ApiClient.convertToType(data['GroupID'], 'Integer');
      }
      if (data.hasOwnProperty('CompanyFunctionID')) {
        obj['CompanyFunctionID'] = ApiClient.convertToType(data['CompanyFunctionID'], 'Integer');
      }
      if (data.hasOwnProperty('IsPrivate')) {
        obj['IsPrivate'] = ApiClient.convertToType(data['IsPrivate'], 'Boolean');
      }
      if (data.hasOwnProperty('IntegrationSourceID')) {
        obj['IntegrationSourceID'] = ApiClient.convertToType(data['IntegrationSourceID'], 'Integer');
      }
      if (data.hasOwnProperty('PageScreenshotImageURI')) {
        obj['PageScreenshotImageURI'] = ApiClient.convertToType(data['PageScreenshotImageURI'], 'String');
      }
      if (data.hasOwnProperty('ProductFilteringEnabled')) {
        obj['ProductFilteringEnabled'] = ApiClient.convertToType(data['ProductFilteringEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('GeoAreaFilteringEnabled')) {
        obj['GeoAreaFilteringEnabled'] = ApiClient.convertToType(data['GeoAreaFilteringEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('CustomerFilteringEnabled')) {
        obj['CustomerFilteringEnabled'] = ApiClient.convertToType(data['CustomerFilteringEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('TrackingLevel1FilteringEnabled')) {
        obj['TrackingLevel1FilteringEnabled'] = ApiClient.convertToType(data['TrackingLevel1FilteringEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('TrackingLevel2FilteringEnabled')) {
        obj['TrackingLevel2FilteringEnabled'] = ApiClient.convertToType(data['TrackingLevel2FilteringEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('TrackingLevel3FilteringEnabled')) {
        obj['TrackingLevel3FilteringEnabled'] = ApiClient.convertToType(data['TrackingLevel3FilteringEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('TrackingLevel4FilteringEnabled')) {
        obj['TrackingLevel4FilteringEnabled'] = ApiClient.convertToType(data['TrackingLevel4FilteringEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('CompanyLegalEntityFilteringEnabled')) {
        obj['CompanyLegalEntityFilteringEnabled'] = ApiClient.convertToType(data['CompanyLegalEntityFilteringEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('CompanyFunctionFilteringEnabled')) {
        obj['CompanyFunctionFilteringEnabled'] = ApiClient.convertToType(data['CompanyFunctionFilteringEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('Updated')) {
        obj['Updated'] = ApiClient.convertToType(data['Updated'], 'Date');
      }
      if (data.hasOwnProperty('PageScreenshotImageTaken')) {
        obj['PageScreenshotImageTaken'] = ApiClient.convertToType(data['PageScreenshotImageTaken'], 'Date');
      }
      if (data.hasOwnProperty('NameFI')) {
        obj['NameFI'] = ApiClient.convertToType(data['NameFI'], 'String');
      }
      if (data.hasOwnProperty('NameEN')) {
        obj['NameEN'] = ApiClient.convertToType(data['NameEN'], 'String');
      }
      if (data.hasOwnProperty('NameSE')) {
        obj['NameSE'] = ApiClient.convertToType(data['NameSE'], 'String');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} GroupID
   */
  exports.prototype['GroupID'] = undefined;
  /**
   * @member {Integer} CompanyFunctionID
   */
  exports.prototype['CompanyFunctionID'] = undefined;
  /**
   * @member {Boolean} IsPrivate
   * @default false
   */
  exports.prototype['IsPrivate'] = false;
  /**
   * @member {Integer} IntegrationSourceID
   */
  exports.prototype['IntegrationSourceID'] = undefined;
  /**
   * @member {String} PageScreenshotImageURI
   * @default ''
   */
  exports.prototype['PageScreenshotImageURI'] = '';
  /**
   * @member {Boolean} ProductFilteringEnabled
   * @default false
   */
  exports.prototype['ProductFilteringEnabled'] = false;
  /**
   * @member {Boolean} GeoAreaFilteringEnabled
   * @default false
   */
  exports.prototype['GeoAreaFilteringEnabled'] = false;
  /**
   * @member {Boolean} CustomerFilteringEnabled
   * @default false
   */
  exports.prototype['CustomerFilteringEnabled'] = false;
  /**
   * @member {Boolean} TrackingLevel1FilteringEnabled
   * @default false
   */
  exports.prototype['TrackingLevel1FilteringEnabled'] = false;
  /**
   * @member {Boolean} TrackingLevel2FilteringEnabled
   * @default false
   */
  exports.prototype['TrackingLevel2FilteringEnabled'] = false;
  /**
   * @member {Boolean} TrackingLevel3FilteringEnabled
   * @default false
   */
  exports.prototype['TrackingLevel3FilteringEnabled'] = false;
  /**
   * @member {Boolean} TrackingLevel4FilteringEnabled
   * @default false
   */
  exports.prototype['TrackingLevel4FilteringEnabled'] = false;
  /**
   * @member {Boolean} CompanyLegalEntityFilteringEnabled
   * @default false
   */
  exports.prototype['CompanyLegalEntityFilteringEnabled'] = false;
  /**
   * @member {Boolean} CompanyFunctionFilteringEnabled
   * @default false
   */
  exports.prototype['CompanyFunctionFilteringEnabled'] = false;
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Date} Updated
   */
  exports.prototype['Updated'] = undefined;
  /**
   * @member {Date} PageScreenshotImageTaken
   */
  exports.prototype['PageScreenshotImageTaken'] = undefined;
  /**
   * @member {String} NameFI
   * @default ''
   */
  exports.prototype['NameFI'] = '';
  /**
   * @member {String} NameEN
   * @default ''
   */
  exports.prototype['NameEN'] = '';
  /**
   * @member {String} NameSE
   * @default ''
   */
  exports.prototype['NameSE'] = '';
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


